<template>
  <div class="'asc-page-plots-wrapper" data-automation-id="wrapper_page_plots">
    <template v-if="anyPrepopulatedPlots">
      <template v-if="arePrepopulatedPlotsHeadersVisible">
        <div class="asc-page-plots-wrapper--plots-header">
          <h2>
            <span>PRE-POPULATED PLOTS</span>
          </h2>
        </div>
      </template>

      <div
        :class="[
          miniPlot
            ? 'asc-page-plots-wrapper--mini'
            : 'asc-page-plots-wrapper--full',
        ]"
      >
        <asc-page-plot-wrapper
          v-for="pagePlot in validPrepopulatedPagePlots"
          :key="pagePlot.id"
          :page-plot="pagePlot"
          :plots-eyeballs-visible="plotsEyeballsVisible"
          :plots-eyeballs-readonly="plotsEyeballsReadonly"
          :is-recommendation-tab="isRecommendationTab"
          v-bind="{ ...$props, ...$attrs }"
        ></asc-page-plot-wrapper>
      </div>

      <template v-if="anyCustomCreatedPagePlots">
        <template v-if="arePrepopulatedPlotsHeadersVisible">
          <div class="asc-page-plots-wrapper--plots-header">
            <h2>
              <span>CUSTOM CREATED PLOTS</span>
            </h2>
          </div>
        </template>

        <div
          :class="[
            miniPlot
              ? 'asc-page-plots-wrapper--mini'
              : 'asc-page-plots-wrapper--full',
          ]"
        >
          <asc-page-plot-wrapper
            v-for="pagePlot in validCustomCreatedPagePlots"
            :key="pagePlot.id"
            :page-plot="pagePlot"
            :is-recommendation-tab="isRecommendationTab"
            v-bind="{ ...$props, ...$attrs }"
          ></asc-page-plot-wrapper>
        </div>
      </template>
    </template>

    <div
      :class="[
        miniPlot
          ? 'asc-page-plots-wrapper--mini'
          : 'asc-page-plots-wrapper--full',
      ]"
    >
      <template v-if="!anyPrepopulatedPlots">
        <asc-page-plot-wrapper
          v-for="pagePlot in validCustomCreatedPagePlots"
          :key="pagePlot.id"
          :page-plot="pagePlot"
          :is-recommendation-tab="isRecommendationTab"
          v-bind="{ ...$props, ...$attrs }"
        ></asc-page-plot-wrapper>
      </template>
    </div>
  </div>
</template>

<script>
import AscPagePlotWrapper from './AscPagePlotWrapper'
import { AscMxRecPermissionMixin } from '@/components/mixins'
export default {
  name: 'AscPagePlotsWrapper',

  components: {
    AscPagePlotWrapper,
  },
  mixins: [AscMxRecPermissionMixin],
  props: {
    allowAddToIssue: {
      type: Boolean,
      default: false,
    },
    pagePlots: {
      type: Array,
      default: () => [],
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    associating: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkGlobalFilter: {
      type: Boolean,
      default: false,
    },
    miniPlot: {
      type: Boolean,
      default: false,
    },
    mxRecPlot: {
      type: Boolean,
      default: false,
    },
    reportsPlot: {
      type: Boolean,
      default: false,
    },
    liveChart: {
      type: Boolean,
      default: true,
    },
    hideHiddenTabs: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsVisible: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsReadonly: {
      type: Boolean,
      default: false,
    },
    onCreatePagePlot: {
      type: Function,
      default: () => {},
    },
    onDuplicatePagePlot: {
      type: Function,
      default: () => {},
    },
    onAddIssueToPagePlot: {
      type: Function,
      default: () => {},
    },
    onClosePagePlot: {
      type: Function,
      default: () => {},
    },
    onSavePagePlot: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    onApplyPagePlot: {
      type: Function,
      default: () => {},
    },
    onDisableSubmit: {
      type: Function,
      default: () => {},
    },
    onDeletePagePlot: {
      type: Function,
      default: () => {},
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    onUpdatePagePlotCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    anyPrepopulatedPlots() {
      return (
        this.miniPlot &&
        this.mxRecPlot &&
        this.pagePlots.filter(item => item.prepopulated).length > 0
      )
    },

    arePrepopulatedPlotsHeadersVisible() {
      return (
        this.miniPlot &&
        this.mxRecPlot &&
        (this.isEditPermissionInvestigate ||
          this.isReadOnlyPermissionInvestigate) &&
        !this.isRecommendationTab &&
        this.pagePlots.filter(item => item.prepopulated).length > 0
      )
    },

    anyCustomCreatedPagePlots() {
      return this.checkGlobalFilter
        ? this.pagePlots.filter(
            item => !item.prepopulated && item.globalFilterValid,
          ).length > 0
        : this.pagePlots.filter(item => !item.prepopulated).length > 0
    },

    validPrepopulatedPagePlots() {
      return this.checkGlobalFilter
        ? this.pagePlots.filter(
            item => item.prepopulated && item.globalFilterValid,
          )
        : this.pagePlots.filter(item => item.prepopulated)
    },

    validCustomCreatedPagePlots() {
      return this.checkGlobalFilter
        ? this.pagePlots.filter(
            item => !item.prepopulated && item.globalFilterValid,
          )
        : this.pagePlots.filter(item => !item.prepopulated)
    },
  },

  watch: {
    pagePlots: {
      deep: true,
      handler(pagePlots) {
        this.pagePlots = pagePlots
      },
    },
  },
}
</script>

<style lang="scss">
.asc-page-plots-wrapper {
  &--invalid-plots {
    margin: 32px 0;
  }

  &--plots-header {
    margin: 0 0 32px 0;
  }

  h2 {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid $gray-300;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-size: 14px;
    color: $gray-600;
  }

  h2 span {
    background: #fff;
    padding: 0 16px;
    text-transform: uppercase;
  }
}

.asc-page-plots-wrapper--full {
  &--page-plot {
    border: 1px solid $gray-300;
    margin-top: 16px;
  }
}

.asc-page-plots-wrapper--mini {
  display: flex;
  flex-wrap: wrap;
}
</style>
